<template>
  <ObPopover
    :placement="fitWidth ? 'bottom' : 'bottom-start'"
    :actions="options"
    :showSelected="true"
    :defaultValue="modelValue"
    :showOverlay="showOverlay"
    :fitWidth="fitWidth"
    @change="onChange"
    @shown="onDropDown"
  >
    <div class="ob-selection ob-selection-content" 
    :class="{
      'fit-width': fitWidth
    }">
      <slot>
        <span class="ob-selection-content__label">{{ label }}</span>
        <SvgIcon :class="{'icon-triangle-down': spread}" name="icon-triangle"></SvgIcon>
      </slot>
    </div>
  </ObPopover>
</template>
<script>

export default {
  name: 'obSelection',
  props: {
    modelValue: {
      type: [String, Number, Object],
      default: ''
    },
    options: {
      type: Object,
      default: () => []
    },
    fitWidth: {
      type: Boolean,
      default: false
    },
    showOverlay: {
      type: Boolean,
      default: false
    },
  },
  emits: ['select'],
  setup (props, { emit }) {

    const { modelValue , options } = toRefs(props)

    const actions = options.value

    const spread = ref(false)

    const label = computed(() => {
      const selectedItem = options.value.find(i => i.value == modelValue.value) || {}
      return selectedItem.label
    })

    function onChange (val) {
      if (modelValue.value !== val.value) {
        emit('update:modelValue', val.value)
      }
      emit('select', val)
    }

    function onDropDown (val) {
      spread.value = val
    }

    watch(options, (val) => {
      actions.value = [ ...val ]
    }, {
      immediate: true,
      deep: true
    })

    return {
      label,
      spread,
      actions,
      onChange,
      onDropDown
    }
  }
}
</script>

<style lang="postcss" scoped>
  .ob-selection-content {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(246, 246, 246, 1);
    padding: 12px 20px;
    border-radius: var(--radius-xs);
    cursor: pointer;
  }
  .ob-selection-content__label {
    flex: 1;
    font-size: 14px;
    color: var(--color-text-secondary);
  }
  .icon-triangle {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin-left: 2px;
    color: var(--color-text-secondary);
    transition: transform .3s;
    transform: rotate(0deg);
  }
  .icon-triangle-down {
    transform: rotate(-180deg);
  }
  .fit-width {
    box-sizing: border-box;
    justify-content: space-between;
    width: 100%;
    background-color: var(--color-background-secondary);
    border-radius: 0;
  }
</style>